import { types as t, Instance } from 'mobx-state-tree';
import Sensor from '~/mst/models/device/sensor';

const AirmarSensor = t
  .compose(
    t.model({
      precipitation_unit: t.frozen(),
      pressure_unit: t.frozen(),
      temperature_unit: t.frozen(),
      windspeed_unit: t.frozen()
    }),
    Sensor
  )
  .named('Airmar');

export interface IAirmarSensor extends Instance<typeof AirmarSensor> {}

export default AirmarSensor;
